import { checkVisibility } from "../utilities";

const model = {
    singleValue: 'true',
    secondValue: 'true',
    thirdValue: 'true',
    numericValue: 10,
    arrayValue: ['true']
};

describe('Utilities', () => {
    describe('checkVisibility', () => {
        describe('equal', () => {
            it('should return true when matching value is equal', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true',
                                    operator: 'equal'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return true when comparing a number with a text value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '10',
                                    operator: 'equal'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT equal', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'not true',
                                    operator: 'equal'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });

        describe('notEqual', () => {
            it('should return true when matching value is NOT equal', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'not true',
                                    operator: 'notEqual'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when comparing a number with a text value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '10',
                                    operator: 'notEqual'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });

            it('should return false when matching value is equal', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true',
                                    operator: 'notEqual'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('greaterThan', () => {
            it('should return true when matching value is greater than value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '2',
                                    operator: 'greaterThan'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT greater than value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '20',
                                    operator: 'greaterThan'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('lessThan', () => {
            it('should return true when matching value is less than value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '20',
                                    operator: 'lessThan'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT less than value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'numericValue',
                                    value: '2',
                                    operator: 'lessThan'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('isDefined', () => {
            it('should return true when matching value is defined', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    operator: 'isDefined'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT defined', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'notDefined',
                                    operator: 'isDefined'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('contains', () => {
            it('should return true when matching value is contained in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'checkbox',
                                    value: 'val1',
                                    operator: 'contains'
                                }
                            ]
                        }
                    },
                    model: {
                        checkbox: {
                            val1: true,
                            val2: false
                        }
                    }
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT contained in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'checkbox',
                                    value: 'val2',
                                    operator: 'contains'
                                }
                            ]
                        }
                    },
                    model: {
                        checkbox: {
                            val1: true,
                            val2: false
                        }
                    }
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('in', () => {
            it('should return true when matching value is in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'arrayValue',
                                    value: 'true',
                                    operator: 'in'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is NOT in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'arrayValue',
                                    value: 'not true',
                                    operator: 'in'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
        describe('notIn', () => {
            it('should return true when matching value is NOT in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'arrayValue',
                                    value: 'not true',
                                    operator: 'notIn'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching value is in value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'arrayValue',
                                    value: 'true',
                                    operator: 'notIn'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });

        describe('single value', () => {
            it('should return true when matching a single value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when NOT matching a single value', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'not true'
                                }
                            ]
                        }
                    },                
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });

        describe('nested dependencies', () => {
            it('should return true when matching a dependency with a nested dependency', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true'
                                },
                                {
                                    items: [
                                        {
                                            name: 'secondValue',
                                            value: 'true'
                                        },
                                        {
                                            name: 'thirdValue',
                                            value: 'true'
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching ONLY a nested dependency', () => {
                // singleValue is not correct, but secondValue is
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'not true'
                                },
                                {
                                    items: [
                                        {
                                            name: 'secondValue',
                                            value: 'true'
                                        },
                                        {
                                            name: 'thirdValue',
                                            value: 'not true'
                                        }
                                    ],
                                    operator: 'or'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });

            it('should return false when matching ONLY a parent dependency', () => {
                // singleValue is correct, but secondValue is not
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true'
                                },
                                {
                                    items: [
                                        {
                                            name: 'secondValue',
                                            value: 'not true'
                                        },
                                        {
                                            name: 'thirdValue',
                                            value: 'true'
                                        }
                                    ],
                                    operator: 'and'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });

            it('should return true when child dependency is OR', () => {
                // singleValue is correct, but secondValue is not
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true'
                                },
                                {
                                    items: [
                                        {
                                            name: 'secondValue',
                                            value: 'not true'
                                        },
                                        {
                                            name: 'thirdValue',
                                            value: 'true'
                                        }
                                    ],
                                    operator: 'or'
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(true);
            });

            it('should return false when matching a dependency with a deeply nested dependency', () => {
                const isVisible = checkVisibility({
                    item: {
                        dependencies: {
                            items: [
                                {
                                    name: 'singleValue',
                                    value: 'true'
                                },
                                {
                                    items: [
                                        {
                                            name: 'secondValue',
                                            value: 'true'
                                        },
                                        {
                                            items: [
                                                {
                                                    name: 'thirdValue',
                                                    value: 'false'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    model
                });

                expect(isVisible).toEqual(false);
            });
        });
    });
});


// WEBPACK FOOTER //
// ./src/components/__tests__/utilities.test.js